import React, { useCallback } from 'react';
import clsx from 'clsx';
import { Link, Typography } from '@americanexpress/aqx-components';
import { isBrowser } from 'acq-utils/lib/misc';
import styles from './__styles__/index.scss?modules';

const getBrowserHref = () => {
  return isBrowser() ? window.location.href : '';
};

const ErrorView = ({ data = {}, isPrequal = false }) => {
  const {
    cta,
    ctas,
    expiredEepVal,
    header,
    subheader,
    actions = [],
    message
  } = data;

  const eepPart = expiredEepVal ? `/${expiredEepVal}` : '';
  const url = isPrequal ? getBrowserHref() : `${cta?.url}${eepPart}`;
  const ctaText = isPrequal ? 'Refresh' : cta?.text;

  const buildActionDisplay = useCallback(
    actions => {
      return (actions || []).reduce((msgList, action) => {
        if (action.message?.text) {
          msgList.push(<p className={styles.message}>{action.message.text}</p>);
        }
        if (action.message?.phoneNumber) {
          msgList.push(
            <Link
              className={styles.phoneNumber}
              to={action.message.phoneNumber?.href}
            >
              {action.message.phoneNumber?.text}
            </Link>
          );
        }
        return msgList;
      }, []);
    },
    [actions]
  );

  const buildCtas = useCallback(
    ctas => {
      return (ctas || []).reduce((ctaList, cta) => {
        const { url, text } = cta;
        ctaList.push(
          <Link className={clsx(styles.multi, styles['aexp-button'])} href={url}>
            {text}
          </Link>
        );
        return ctaList;
      }, []);
    },
    [ctas]
  );

  return (
    <div className={styles.errorView}>
      {header && <Typography className={styles.header}>{header}</Typography>}
      {subheader && (
        <Typography className={styles.subheader}>{subheader}</Typography>
      )}
      {actions && <div className={styles.action}>{buildActionDisplay(actions)}</div>}
      {message && <Typography className={styles.message}>{message}</Typography>}
      {cta && (
        <div className={styles.buttons}>
          <Link className={styles['aexp-button']} href={url}>
            {ctaText}
          </Link>
        </div>
      )}
      {ctas && <div className={styles.buttons}>{buildCtas(data.ctas)}</div>}
    </div>
  );
};

export default React.memo(ErrorView);
